<div class="row justify-content-center">
    <div class="col-sm-12 col-md-8 col-lg-4">
        <mat-card class="cardWithShadow m-t-24">
            <mat-card-content>
                <mat-card-title>{{ 'LABEL.CHANGE_PASSWORD_LABEL' | translate }} </mat-card-title>
                <mat-card-subtitle class="mat-body-1">{{ 'LABEL.CHANGE_PASSWORD_DESCRIPTION' | translate }}</mat-card-subtitle>
                <form class="m-t-24" [formGroup]="changepasswordForm">
                    <!-- input -->
                    <mat-label class="mat-subtitle-2 f-w-600 m-b-8 d-block">{{ 'LABEL.CURRENT_PASSWORD' | translate }}</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <input matInput type="password" [type]="hideCurrentPassword ? 'password' : 'text'"
                            formControlName="currentpassword" />
                        <button mat-icon-button matSuffix (click)="hideCurrentPassword = !hideCurrentPassword"
                            type="button">
                            <mat-icon>{{hideCurrentPassword ? 'visibility_off' :
                                'visibility'}}</mat-icon>
                        </button>
                    </mat-form-field>
                    <!-- input -->
                    <mat-label class="mat-subtitle-2 f-w-600 m-b-8 d-block">{{ 'LABEL.NEW_PASSWORD' | translate }}</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <input matInput type="password" [type]="hideNewPassword ? 'password' : 'text'"
                            formControlName="newpassword" />
                        <button mat-icon-button matSuffix (click)="hideNewPassword = !hideNewPassword" type="button">
                            <mat-icon>{{hideNewPassword ? 'visibility_off' :
                                'visibility'}}</mat-icon>
                        </button>
                    </mat-form-field>

                </form>
                <div class="text-right p-0 p-t-16">

                    <button mat-flat-button color="primary" class="m-r-8 position-relative" (click)="changePassword()" [disabled]="changepasswordForm.invalid || isLoading" [ngClass]="{ 'loading': isLoading }">
                        <span *ngIf="isLoading" class="spinner-container">
                            <mat-spinner [diameter]="20"></mat-spinner>
                        </span>
                        <span>{{ 'LABEL.CHANGE_PASSWORD_LABEL' | translate }}</span>
                    </button>
        
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</div>